import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { KsefIntegration } from "@/models/api/administration/contractors/ContractorExportIntegrationSettingResponse";
import {
  getContractorKsefIntegrationsSetting,
  saveKsefIntegrationSetting,
} from "@/requests/administration/contractors/contractorKsefIntegrationAdministration";

export interface AdministrationContractorKsefIntegrationInterface {
  ksefIntegration: KsefIntegration;
}

export const AdministrationContractorKsefIntegrationState: AdministrationContractorKsefIntegrationInterface = {
  ksefIntegration: new KsefIntegration(),
};

const AdministrationContractorExportAndIntegrationModule = defineModule({
  state: AdministrationContractorKsefIntegrationState as AdministrationContractorKsefIntegrationInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setContractorKsefIntegration(state, param: KsefIntegration) {
      state.ksefIntegration = param;
    },
  },
  actions: {
    async downloadContractorKsefIntegration(context) {
      const { commit, rootState } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId !== null) {
        const response = await getContractorKsefIntegrationsSetting(
          rootState.administration.contractors.list.selectedContractorId as string
        );
        commit.setContractorKsefIntegration(response);
      }
    },
    async saveKsefIntegration(context) {
      const { rootState, rootDispatch, state, dispatch } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId !== null) {
        await saveKsefIntegrationSetting(
          rootState.administration.contractors.list.selectedContractorId,
          state.ksefIntegration
        );
        await dispatch.downloadContractorKsefIntegration();
        rootDispatch.popup.addSavedOkSnackbar();
      }
    },
  },
});

export default AdministrationContractorExportAndIntegrationModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationContractorExportAndIntegrationModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(
    context,
    AdministrationContractorExportAndIntegrationModule
  );
